import cookie from 'js-cookie';
import hashMap from '../../i18n/hash';
import get from 'lodash-es/get'
import formatString from './format-string';
import moment from 'moment';

const DEFAULT_LOCALE = 'en-US';

export const momentI18nMap = {
  "gov-EN": "en",
  "en-US": "en",
  "es-ES": "es",
  "de-DE": "de",
  "zh-CN": "zh-cn",
  "zh-TW": "zh-tw",
  "fr-FR": "fr",
  "pt-PT": "pt",
  "jp-JP": "ja",
  "ru-RU": "ru",
  "ko-KO": "ko",
  "it-IT": "it",
  "vi-VN": "vi",
  "nl-NL": "nl",
  "tr-TR": "tr",
  "id-ID": "id",
  "pl-PL": "pl",
  "sv-SE": "sv",
}

function getLocale() {
  const cookieLang = cookie.get('_zm_lang');
  const isGov = window.ZBilling?.isGov;
  if (isGov && !hashMap[cookieLang]) {
    return 'gov-EN';
  }
  return cookieLang || DEFAULT_LOCALE;
}

function setMomentI18n() {
  const momentLocale = momentI18nMap[getLocale()] || "en";

  return moment.locale(momentLocale);
}

const installI18n = () => {
  const modules = require.context('../../i18n', true, /i18n-([a-zA-Z-]+)\.js$/);
  const locale = getLocale();
  setMomentI18n();
  const messages = modules
    .keys()
    .reduce((pre, key) => {
      return {
        ...pre,
        ...modules(key).default,
      };
    }, {});
  function translate(path, params = []) {
    const array = path.split('.');
    const current = messages[locale] || messages[DEFAULT_LOCALE];
    return formatString(get(current, path) || path, params);
  }
  return {
    locale,
    messages,
    translate,
  };
}

const {
  locale,
  translate,
} = installI18n();

const translateMixins = {
  methods: {
    __$t(...args) {
      return translate(...args);
    },
  },
};

export {
  locale,
  translate,
  translateMixins,
}
